<template>
  <div>
    <el-form :model="form" ref="dynamicForm" label-width="100px">
      <el-form-item prop="tableName" label="表名称">
        <el-col :span="5">
          <el-input v-model="form.tableName"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="模块名称">
        <el-select v-model="form.tableModule" placeholder="模块名称">
          <el-option label="代码生成" value="db"></el-option>
          <el-option label="其他暂无" value="nothing"></el-option>
        </el-select>
      </el-form-item>
      <el-row v-for="(field, index) in form.generateFieldEntities" :key="index">
        <el-col :span="3">
          <el-form-item label="字段名：">
            <el-input v-model="field.filedName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-select v-model="field.dataType" placeholder="数据类型">
            <el-option label="字符串" value="string"></el-option>
            <el-option label="整形" value="int"></el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-select
            v-model="field.typeDetail"
            filterable
            allow-create
            placeholder="类型详情"
          >
            <el-option
              v-for="item in optionsType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-select v-model="field.addType" placeholder="类型补充">
            <el-option label="非负数" value="unsigned"></el-option>
            <el-option label="空字符" value=""></el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-select v-model="field.isNull" placeholder="是否为空">
            <el-option label="可以为空" value=""></el-option>
            <el-option label="不可为空" value="not null"></el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-select
            v-model="field.filedDefault"
            filterable
            allow-create
            placeholder="默认值"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-select v-model="field.filedStrategy" placeholder="字段策略">
            <el-option label="主键自增" value="AUTO_INCREMENT"></el-option>
            <el-option label="无策略" value=""></el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-form-item label="备注：">
            <el-input v-model="field.fieldComment"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="3">
          <el-button
            icon="el-icon-minus"
            @click="removeField(index)"
          ></el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="3">
          <el-form-item label="主键锁定：">
            <el-input v-model="form.primaryKey"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="索引锁定：">
            <el-input v-model="form.key"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="外键锁定：">
            <el-input v-model="form.foreignKey"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-button type="primary" @click="addField">新增行</el-button>
      <el-button type="primary" @click="submitForm">提交</el-button>
    </el-form>
    <el-popover placement="right" width="1200" trigger="click">
      <el-scrollbar style="height: 300px;"
        ><div id="article"
          v-for="text in texts" :key="text.id" style="padding: 16px;">
          {{ text.content }}
        </div>
      </el-scrollbar>
      <el-button slot="reference">click 激活</el-button>
    </el-popover>
  </div>
</template>

<style>
#article {
  white-space: pre;
}
</style>

<script>
import { createTable } from '../../api'

export default {
  data() {
    return {
      form: {
        tableName: '',
        tableModule: '',
        generateFieldEntities: [
          {
            filedName: '',
            dataType: '',
            typeDetail: '',
            addType: '',
            isNull: '',
            filedDefault: '',
            fieldComment: '',
            filedStrategy: ''
          }
        ],
        primaryKey: '',
        key: '',
        foreignKey: ''
      },
      options: [
        {
          value: 'null',
          label: '空'
        },
        {
          value: '0',
          label: '零'
        },
        {
          value: '',
          label: '空字符串'
        },
        {
          value: 'CURRENT_TIMESTAMP',
          label: '当前时间'
        }
      ],
      optionsType: [
        {
          value: '11',
          label: '11'
        },
        {
          value: '50',
          label: '50'
        },
        {
          value: '100',
          label: '100'
        },
        {
          value: '200',
          label: '200'
        }
      ],
      codeList: [],
      texts: [
        { id: 1, content: "drop table if exists table \r\nCREATE TABLE table (\r\ntableId int(11) unsigned not null default 0 AUTO_INCREMENT comment '自增主键',\r\ntableName string(50) null null default null null comment '字段名',\r\nPRIMARY KEY ( tableName ) USING BTREE\r\n)" },
        { id: 2, content: "drop table if exists table \r\nCREATE TABLE table (\r\ntableId int(11) unsigned not null default 0 AUTO_INCREMENT comment '自增主键',\r\ntableName string(50) null null default null null comment '字段名',\r\nPRIMARY KEY ( tableName ) USING BTREE\r\n)" },
        { id: 3, content: '第三段文字内容' }
      ]
    }
  },
  mounted() {},

  methods: {
    addField() {
      const newIndex = this.form.generateFieldEntities.length
      this.form.generateFieldEntities.push({ filedName: '', dataType: '' })
    },
    removeField(index) {
      this.form.generateFieldEntities.splice(index, 1)
    },
    submitForm() {
      this.$refs.dynamicForm.validate(valid => {
        if (valid) {
          // 进行其他操作，如发送网络请求或存储数据等
          const data = {
            dbGenerateVo: this.form
          }
          // 网络请求
          let result = createTable(this.form)
          this.codeList = result

          console.log('result.data', result)
          console.log('result.data', this.codeList)
        } else {
          console.log('表单校验失败')
        }
      })
    }
  }
}
</script>

<!-- <el-form
      :model="dynamicValidateForm"
      ref="dynamicValidateForm"
      label-width="100px"
      class="demo-dynamic"
    >
      <el-form-item
        prop="email"
        label="邮箱"
        :rules="[
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ]"
      >
      <el-col :span="8">
        <el-input v-model="dynamicValidateForm.email"></el-input>
      </el-col>
      </el-form-item>
      <el-form-item
        v-for="(domain, index) in dynamicValidateForm.domains"
        :label="'域名' + index"
        :key="domain.key"
        :prop="'domains.' + index + '.value'"
        :rules="{
          required: true,
          message: '域名不能为空',
          trigger: 'blur'
        }"
      >
      <el-col :span="8">
        <el-input v-model="domain.value"></el-input>
      </el-col>
        <el-button @click.prevent="removeDomain(domain)">删除</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('dynamicValidateForm')"
          >提交</el-button
        >
        <el-button @click="addDomain">新增域名</el-button>
        <el-button @click="resetForm('dynamicValidateForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
        dynamicValidateForm: {
          domains: [{
            value: ''
          }],
          email: ''
        }
    }
  },
  mounted() {},

  methods: {
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      removeDomain(item) {
        var index = this.dynamicValidateForm.domains.indexOf(item)
        if (index !== -1) {
          this.dynamicValidateForm.domains.splice(index, 1)
        }
      },
      addDomain() {
        this.dynamicValidateForm.domains.push({
          value: '',
          key: Date.now()
        });
      }
  }
}
</script> -->
